import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLtRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m19.214 38.414-2.121-2.121L29.385 24 17.093 11.708l2.121-2.121L33.628 24z" }) }) })
});
export default SvgArrowLtRight;
